<template>
    <div class="previous-step__container">
        <a v-on:click.prevent="setStep(step)" class="previous-step__link">{{ linkText }}</a>
    </div>
</template>

<script>
import { mapMutations } from "vuex";

export default {
    props: {
        step: {
            type: Number,
            default: 0,
        },
        linkText: {
            type: String,
            default: "Back to previous step",
        },
    },

    methods: {
        ...mapMutations("OSB", ["setStep"]),
    },
};
</script>

<style lang="scss" scoped>
.previous-step {
    &__container {
        margin-top: 30px;
        display: flex;

        @media (max-width: 767px) {
            justify-content: center;
        }
    }

    &__link {
        font-family: "Encode Sans";
        font-size: 15px;
        color: #0293d6;

        &:hover {
            cursor: pointer;
        }

        &::before {
            display: inline-block;
            content: url("/images/link-icon.svg");
            width: 22px;
            height: 22px;
            transform-origin: center;
            transform: rotate(183deg) translateY(-5px);
            margin-right: 0.5rem;
        }
    }
}
</style>